import { render, staticRenderFns } from "./Set.vue?vue&type=template&id=85ef582a&scoped=true"
import script from "./Set.vue?vue&type=script&lang=js"
export * from "./Set.vue?vue&type=script&lang=js"
import style0 from "./Set.vue?vue&type=style&index=0&id=85ef582a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ef582a",
  null
  
)

export default component.exports